angular.
module("dx.webapp.archive").
controller("DxArchiveController", function ArchiveController(
	$rootScope,
	ArchiveRepository,
	ExamRepository,
	group,
	course,
	dxApi,
	dxDialog,
	dxLocalize
) {
	"use strict";

	var self = this;

	self.exams = [];
	self.examTemplates = [];
	self.rubrics = [];
	self.examsSelection = {
		examIds: [],
		examParent: "",
	};
	self.isExamTemplate = false;

	self.loading = {
		examTemplates: true,
		exams: true,
		rubrics: true,
		groups: true,
	};

	self.activeTab = "examTemplates";

	self.ArchiveRepository = ArchiveRepository;
	ArchiveRepository.refreshArchive().then(function done() {
		self.loading.groups = false;
	});

	self.ExamRepository = ExamRepository;


	dxApi.v1.gradingMatrix.list(true).then(function success(response) {
		self.loading.rubrics = false;
		self.rubrics = response.data.gradingMatrices;
	});

	dxApi.v1.exams.get(null, null, true).then(function onGetExamsSuccess(res) {
		self.exams = res.data;

		self.loading.exams = false;

		// Collect group IDs into an array to query for.
		var groupIds = [];
		for (var i = 0; i < res.data.length; ++i) {
			var groupId = res.data[i].groupId;
			// Add only unique group IDs
			if (groupId && groupIds.indexOf(groupId) === -1) {
				groupIds.push(groupId);
			}
		}

		if (groupIds.length === 0) {
			return;
		}

		// Retrieves and assigns group names onto exams that belong to a group.
		function onGetGroupsSuccess(response) {
			var groups = response.data;

			for (var j = 0; j < self.exams.length; ++j) {
				setGroupNameOnExam(self.exams[j]);
			}

			function setGroupNameOnExam(exam) {
				for (var k = 0; k < groups.length; ++k) {
					if (groups[k].id === exam.groupId) {
						exam.groupName = groups[k].title;
					}
				}
			}
		}

		// Query API for info on groups and set data.
		dxApi.v1.groups.get(groupIds).then(onGetGroupsSuccess);
	});

	dxApi.v1.examTemplates.get(true).then(function onGetExamsSuccess(res) {
		self.examTemplates = res.data;
		self.loading.examTemplates = false;
	});

	self.restoreExam = function restoreExam(exam) {
		exam.isArchived = false;
		var examIndex = self.exams.indexOf(exam);

		if (examIndex > -1) {
			self.exams.splice(examIndex, 1);
		}

		var examTemplateIndex = self.examTemplates.indexOf(exam);

		if (examTemplateIndex > -1) {
			self.examTemplates.splice(examTemplateIndex, 1);
		}

		ExamRepository.save(exam);
	};

	self.restoreMatrix = function restoreMatrix(matrix) {
		matrix.isArchived = false;
		dxApi.v1.gradingMatrix.save(matrix);
		//Remove the restored matrix from the list of rubrics shown
		self.rubrics = self.rubrics.filter(function compare(element) {
			return element.id !== matrix.id;
		});
	};

	self.restoreGroup = function restoreGroup(g) {
		group.setArchived(g.id, false).then(function onArchived() {
			var index = ArchiveRepository.groups.indexOf(g);

			if (index > -1) {
				ArchiveRepository.groups.splice(index, 1);
			}
		});
	};

	self.restoreCourse = function restoreCourse(c) {
		c.isArchived = false;
		course.update(c).then(function onRestoreCourse() {
			var index = ArchiveRepository.courses.indexOf(c);

			if (index > -1) {
				ArchiveRepository.courses.splice(index, 1);
			}
		});
	};

	self.isActiveTab = function isActiveTab(tab) {
		return self.activeTab === tab;
	};

	self.setTab = function setTab(tab) {
		self.clearExamSelection();
		self.activeTab = tab;
	};

	// Hide exam logic.
	self.getSelectedExams = function getSelectedExams() {
		return self.examsSelection;
	};

	self.hideExam = function hideExam() {
		var requestBody = {
			examIds: self.examsSelection.examIds,
			hidden: true,
		};

		self.isExamTemplate = self.examsSelection.examParent === 0;

		if (self.isExamTemplate) {
			dxApi.v1.examTemplates.hide(requestBody).then(self.hideSuccessHandler, self.hideFailHandler);
		} else {
			dxApi.v1.exams.hide(requestBody).then(self.hideSuccessHandler, self.hideFailHandler);
		}
	};

	self.hideSuccessHandler = function hideSuccessHandler() {
		$rootScope.$broadcast("notification:success", dxLocalize.get("Feedback.SuccessDeleted"));
		self.updateExamLists();
		self.closeHideExamDialog();
	};

	self.deleteFailHandler = function deleteFailHandler() {
		$rootScope.$broadcast("notification:error", dxLocalize.get("Feedback.ErrorDeleting"));
		self.clearExamSelection();
		self.closeHideExamDialog();
	};

	self.updateExamLists = function updateExamLists() {
		if (self.isExamTemplate) {
			self.filterExamArrays(self.examTemplates);
		} else {
			self.filterExamArrays(self.exams);
		}
	};

	self.filterExamArrays = function filterExamArrays(exams) {
		for (var i = exams.length - 1; i >= 0; i--) {
			if (self.examsSelection.examIds.includes(exams[i].id)) {
				var examIndex = exams.indexOf(exams[i]);
				exams.splice(examIndex, 1);
			}
		}
		self.clearExamSelection();
	};

	self.clearExamSelection = function clearExamSelection() {
		self.examsSelection.examIds = [];
		self.examsSelection.examParent = "";
	};

	// Hide exam dialog.
	self.openHideExamDialog = function openHideExamDialog(examIds, examParent) {
		self.examsSelection = {
			examIds: examIds,
			examParent: examParent,
		};

		var scope = $rootScope.$new();
		scope.hideExam = self.hideExam;
		scope.getSelectedExams = self.getSelectedExams;
		scope.closeHideExamDialog = function closeHideExamDialog() {
			dxDialog.closeMostRecent();
		};

		dxDialog.show({
			templateUrl: "tmpl/exams/hide-exam.html",
			$scope: scope,
		});
	};

	self.closeHideExamDialog = function closeHideExamDialog() {
		dxDialog.closeMostRecent();
	};

	// Checkboxes handlers.
	self.isExamSelected = function isExamSelected(examId) {
		return self.examsSelection.examIds.indexOf(examId) > -1;
	};

	self.toggleSelectExam = function toggleSelectExam(examId, examParent) {
		if (self.isExamSelected(examId)) {
			self.examsSelection.examIds.splice(self.examsSelection.examIds.indexOf(examId), 1);
		} else {
			self.examsSelection.examIds.push(examId);
			self.examsSelection.examParent = examParent;
		}
	};

	self.isAllExamsSelected = function isAllExamsSelected(exams) {
		return self.examsSelection.examIds.length === exams.length;
	};

	self.toggleSelectAllExams = function toggleSelectAllExams(exams) {
		var examsIds = [];

		for (var i = 0; i < exams.length; ++i) {
			var examId = exams[i].id;
			examsIds.push(examId);
		}
		if (self.isAllExamsSelected(exams)) {
			self.clearExamSelection();
		} else {
			self.examsSelection.examIds = examsIds;
			self.examsSelection.examParent = exams[0].parent;
		}
	};
});
